import * as Preact from "preact";
var h = Preact.h;

export function preventEvent(e) {
	if (e) {
		if (e.stopImmediatePropagation) e.stopImmediatePropagation();
		if (e.stopPropagation) e.stopPropagation();
		e.preventDefault();
	}
	return false;
}
export function mc(...classes){
    return classes.join(" ")
}
export function m(...classes){
    return classes.join(" ")
}
export function f(...childs){
    return Preact.h(Preact.Fragment,{},childs)
}
export function Head(children: Preact.JSX.Element[]){
    
    if(typeof window === 'undefined'){
        return <head>{children}</head>
    }else{
        
        Preact.render(children,document.head);
    }
}
export function getParentUidEl(el){
    var parent = el;
    while(parent){
        if(parent.dataset && parent.dataset.uid){
            return parent;
        }
        parent = parent.parentNode;
    }
}
export function arrayHasItems(arr){
    return arr && arr.length > 0;
}
export function and(...items){
    for (let i = 0; i < items.length; i++) {
        const item = items[i];
        if(!item || (Array.isArray(item) && item.length < 1)){
            return false;
        }
    }
    return true;
}
export function or(...items){
    for (let i = 0; i < items.length; i++) {
        const item = items[i];
        if(Array.isArray(item)){
            if( item.length > 0){
                return true;

            }
        }else if(item){
            return true;
        }
    }
}
export function isElInViewportForAnimation(el,dist) {

    var bounding = el.getBoundingClientRect();
    
    var height = window.innerHeight || document.documentElement.clientHeight;
    var dif = height - bounding.top;
    if (dif > dist) {
        return true;
    }
}
export class Pointer{

    prevDownEvt = null;
    downEvt = null;
    prevMoveEvt = null;
    moveEvt = null;
    prevUpEvt = null;
    upEvt = null;

    isDown = false;
    clicked = false;
    mouseUpTravelDistance = {x:0,y:0};

    prevTouchStartEvt = null;
    prevTouchMoveEvt = null;
    prevTouchUpEvt = null;
    touchStartEvt = null;
    touchMoveEvt = null;
    touchUpEvt = null;

    constructor(){
        this.setDown({x:0,y:0});
        this.setUp({x:0,y:0});
    }

    setMove(evt){
        if(this.moveEvt == evt){
            return;
        }
        this.prevMoveEvt = this.moveEvt;
        this.moveEvt = evt;
    }
    setDown(evt){
        
        if(evt == this.downEvt){
            return;
        }
        this.clicked = false;
        this.prevDownEvt = this.downEvt;
        this.downEvt = evt;
        this.prevMoveEvt = evt;
        this.moveEvt = evt;
        this.isDown = true;
    }
    setUp(evt){
        if(evt == this.upEvt){
            return;
        }

        this.prevUpEvt = this.upEvt;
        this.upEvt = evt;
        this.isDown = false;
        this.detectClick();
    }
    setClick(evt){
        this.setDown(evt);
        this.prevUpEvt = this.upEvt;
        this.upEvt = evt;
        this.isDown = false;
        this.clicked = true;

    }

    detectClick(){
        this.mouseUpTravelDistance.x = this.upEvt.x - this.downEvt.x ;
        this.mouseUpTravelDistance.y = this.upEvt.y -  this.downEvt.y ;
        
        if((this.mouseUpTravelDistance.x < 5 && this.mouseUpTravelDistance.y < 5) && (this.mouseUpTravelDistance.x > -5 && this.mouseUpTravelDistance.y > -5 )){
            this.clicked = true;
        }else{
            this.clicked = false;
        }
        return this.clicked;
    }
    getMouseMoveTravelDistanceX(){
        return this.moveEvt.x - this.downEvt.x;
    }
    getMouseMoveTravelDistanceY(){
        return this.moveEvt.y - this.downEvt.y;
    }
    detectDoubleClick(){
        var xDist = Math.abs(this.downEvt.x - this.prevDownEvt.x);
        var yDist = Math.abs(this.downEvt.y - this.prevDownEvt.y);

        if((this.downEvt.timeStamp - this.prevDownEvt.timeStamp ) < 500 && xDist < 10 && yDist < 10){
            return true;
        }
        return false;
    }

    setTouchStart(evt){
        if(evt == this.touchStartEvt){
            return;
        }
        this.clicked = false;
        this.prevTouchUpEvt = this.touchStartEvt;
        this.touchStartEvt = evt;
        this.touchMoveEvt = evt;
        this.isDown = true;
    }
    setTouchMove(evt){
        if(evt == this.touchMoveEvt){
            return;
        }
        this.prevTouchMoveEvt = this.touchMoveEvt;
        this.touchMoveEvt = evt;
    }
    setTouchUp(evt){
        if(evt == this.touchUpEvt){
            return;
        }
        this.prevTouchUpEvt = this.touchUpEvt;
        this.touchUpEvt = evt;
        this.isDown = false;
    }
    getTouchTravelDistanceX(){
        return this.touchMoveEvt.targetTouches[0].clientX - this.touchStartEvt.targetTouches[0].clientX;
    }
    getTouchTravelDistanceY(){
        return this.touchMoveEvt.targetTouches[0].clientY - this.touchStartEvt.targetTouches[0].clientY;
    }
}